import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/vercel/path0/components/contact/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactContent"] */ "/vercel/path0/components/contact/ContactContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HtmlLangSync"] */ "/vercel/path0/components/i18n/HtmlLangSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicFooter"] */ "/vercel/path0/components/landing/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/vercel/path0/components/landing/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.14.2_next@15.2.8_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1__react@18.3.1/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
